<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent;">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-decagram</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.productService') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <v-divider vertical  style="margin: 0 10px 0 10px;"/>
      <template>
        <span style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px;">{{ name }}</span>     
        <!-- <v-btn-toggle
          v-model="icon" 
          @change="handleChangeIsModified"
        >
          <v-btn :value="'mdi-information'" @click="content.Icon = 'mdi-information'" text>
            <v-icon>mdi-information</v-icon>
          </v-btn>
          <v-btn :value="'mdi-alert'" @click="content.Icon = 'mdi-alert'" text>
            <v-icon>mdi-alert</v-icon>
          </v-btn>
          <v-btn :value="'mdi-help-circle'" @click="content.Icon = 'mdi-help-circle'" text>
            <v-icon>mdi-help-circle</v-icon>
          </v-btn>
          <v-btn :value="'mdi-check-circle'" @click="content.Icon = 'mdi-check-circle'" text>
            <v-icon>mdi-check-circle</v-icon>
          </v-btn>
          <v-btn :value="'mdi-email'" @click="content.Icon = 'mdi-email'" text>
            <v-icon>mdi-email</v-icon>
          </v-btn>
          <v-btn :value="'mdi-clock'" @click="content.Icon = 'mdi-clock'" text>
            <v-icon>mdi-clock</v-icon>
          </v-btn>
           <v-btn :value="''" @click="content.Icon = ''" text>
             <v-icon style="opacity: 0.2">mdi-cancel</v-icon>
          </v-btn>
        </v-btn-toggle> -->
      </template>
    </v-toolbar>
    <translate
      v-show="!collapseContent"
      v-model="content.ProductName"
      :languages="languages"
      :label="$t('product.name')"
      @input="handleChangeIsModified"
      style="padding: 0 10px 0 10px;"
    />
    <translate
      v-show="!collapseContent"
      v-model="content.ProductDescription"
      :languages="languages"
      :label="$t('product.description')"
      type="textArea"
      @input="handleChangeIsModified"
      style="padding: 0 10px 0 10px;"
    />
    <v-layout wrap v-show="!collapseContent">
      <v-flex xs4>
        <v-text-field
          v-model="content.ProductPrice"
          :label="$t('product.price')"
          hideDetails
          @input="handleChangeIsModified"
        />
      </v-flex>
      <v-flex xs4>
        <v-checkbox
          v-model="content.ProductPromotion"
          :color="enterpriseColor"
          :label="$t(`product.promotion`)"
          :value="content.ProductPromotion"
        />
      </v-flex>
      <v-flex xs12>
        <translate
          v-model="content.ProductNote"
          :languages="languages"
          :label="$t('food.note')"
          @input="handleChangeIsModified"
          style="padding: 0 10px 0 10px;"
        />
      </v-flex>
 
    </v-layout>
    <select-image
      v-show="!collapseContent"
      v-model="content.ProductImage"
      :isFullWidth="true"
      :enterpriseID="enterpriseID"
      :imageOld='content.ProductImage'
      :imageWidth="600"
      :imageHeight="600"
      :aspectRatio="1/1"
      @input="handleChangeIsModified"
      style="margin-left:0px;margin-top:15px;margin-right: 0px;"
      width="100px"
    />
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import utils from '@/services/utils'
  import Translate from '@/components/Translate'
  import SelectImage from '@/components/SelectImage'
  export default {
    components: {
      Translate,
      SelectImage,
    },
    props: {
      content: {
        type: Object,
        required: true
      },
    },
    data: () => ({
    }),
    computed: {
      ...mapState('app',['collapseContent', 'locale']),
      languages () {
        return this.$store.state.app.Languages
      },
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
      name () {
        const limit = 20
        const aux = this.content.ProductName ? utils.getTranslation (this.content.ProductName, this.locale) : ''
        return aux ? aux.substring(0, limit).concat(aux.length > limit ? '...' : '' ) : ''
      }
    },
    mounted () {
    },
    methods: {
      handleChangeIsModified () {
        this.$store.state.app.isModified = true
      }
    }
  }
</script>

<style scoped>
</style>

